export default __webpack_public_path__ + "3b6ee4629f566a03f01d724e5c0f29c7.png";